import { SurveyElement } from './element';
import { ElementOptions } from './element-options';
import { Expose, Type } from 'class-transformer';

export class SocialMediaShareOptions extends ElementOptions {
  @Expose()
  type!: string;

  @Expose({ name: 'url' })
  to!: string;
}

export class SocialMediaShareElement extends SurveyElement {
  @Expose({ name: 'text' })
  label!: string | null;

  @Expose({ name: 'use_native_share_api' })
  useNativeShareApi!: boolean;

  @Expose()
  @Type(() => SocialMediaShareOptions)
  options!: SocialMediaShareOptions[];
}
